'use client';

import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { FlexColumn, FlexRow } from 'src/components/Atoms/FlexBox';
import DrawerContent from 'src/components/Organisms/DrawerContent/DrawerContent';
import { useState } from 'react';
import useTranslations from 'src/hooks/useTranslations';
import SearchBar from '@effektify/components/SearchBar';
interface GlossarySectionProps {
  glossary?: {
    displayName?: string | null;
    description?: string | null;
  }[] | null;
  onClose: () => void;
  search?: string;
}
;
type GroupedGlossary = Record<string, {
  displayName: string;
  description: string;
}[]>;
const GroupBox = styled(FlexColumn)(({
  theme
}) => ({
  gap: theme.sizes.spacing['07'],
  width: '100%'
}));
const ItemBox = styled(FlexRow)(({
  theme
}) => ({
  gap: theme.sizes.spacing['08'],
  paddingBottom: theme.sizes.spacing['07'],
  borderBottom: `1px solid ${theme.colors.border.primary}`,
  width: '100%'
}));
const GlossarySection: React.FC<GlossarySectionProps> = t0 => {
  const $ = _c(9);
  const {
    glossary,
    onClose,
    search: t1
  } = t0;
  const search = t1 === undefined ? "" : t1;
  const {
    t
  } = useTranslations();
  const [searchTerm, setSearchTerm] = useState(search);
  let t2;
  if ($[0] !== glossary || $[1] !== onClose || $[2] !== searchTerm || $[3] !== t) {
    const filteredGlossary = (glossary?.filter(item => item.displayName && item.description && (item.displayName.toLowerCase().includes(searchTerm.toLowerCase()) || item.description.toLowerCase().includes(searchTerm.toLowerCase()))) || []) as {
      displayName: string;
      description: string;
    }[];
    const orderedGlossary = filteredGlossary.sort(_temp);
    const groupedGlossary = orderedGlossary.reduce(_temp2, {});
    let t3;
    if ($[5] !== onClose) {
      t3 = () => {
        setSearchTerm("");
        onClose();
      };
      $[5] = onClose;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    const onCloseGlossary = t3;
    t2 = filteredGlossary && <DrawerContent title={t("knowledgehubPage.glossary")} onClose={() => onCloseGlossary()}><ItemBox><SearchBar size="medium" placeholder={t("knowledgehubPage.glossarySearch")} value={searchTerm} onChange={setSearchTerm} fullWidth={true} /></ItemBox>{Object.entries(groupedGlossary).map(_temp6)}</DrawerContent>;
    $[0] = glossary;
    $[1] = onClose;
    $[2] = searchTerm;
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[7] !== t2) {
    t3 = <>{t2}</>;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
export default GlossarySection;
export type { GlossarySectionProps };
function _temp(a, b) {
  return a.displayName.localeCompare(b.displayName);
}
function _temp2(groups, item_0) {
  const firstLetter = item_0.displayName ? item_0.displayName.charAt(0).toUpperCase() : "#";
  if (!groups[firstLetter]) {
    groups[firstLetter] = [];
  }
  groups[firstLetter].push(item_0);
  return groups;
}
function _temp3(theme) {
  return {
    color: theme.colors.text.primary,
    flexBasis: "30%"
  };
}
function _temp4(theme_0) {
  return {
    color: theme_0.colors.text.tertiary,
    whiteSpace: "pre-wrap",
    flexBasis: "70%"
  };
}
function _temp5(item_1) {
  return <ItemBox key={item_1.displayName}><Typography variant="heading-sm" sx={_temp3}>{item_1.displayName}</Typography><Typography variant="body-sm" sx={_temp4}>{item_1.description}</Typography></ItemBox>;
}
function _temp6(t0) {
  const [letter, items] = t0;
  return <GroupBox key={letter}><ItemBox><Typography variant="heading-lg">{letter}</Typography></ItemBox>{items.map(_temp5)}</GroupBox>;
}